import React from "react";
import ConfiguracionModule from "./secciones/ConfiguracionModule";

export default function Configuracion() {
  return <ConfiguracionModule />;
}
